export const PLATFORMS = {
  MEDIA: 'media',
  EVENTS: 'events',
};

const LOCAL_HOSTS = ['localhost', '127.0.0.1'];
const LOCAL_PLATFORM_KEY = 'localPlatform';
const isPlatform = value => Object.values(PLATFORMS).includes(value);

// Locally, `?platform=` wins and is remembered; otherwise the last choice from the dev menu,
// then events.
function getLocalPlatform(params) {
  const fromUrl = params.get('platform');

  try {
    if (isPlatform(fromUrl)) {
      localStorage.setItem(LOCAL_PLATFORM_KEY, fromUrl);
      return fromUrl;
    }

    const saved = localStorage.getItem(LOCAL_PLATFORM_KEY);
    if (isPlatform(saved)) {
      return saved;
    }
  } catch {}

  return PLATFORMS.EVENTS;
}

export function switchLocalPlatform(nextPlatform) {
  if (!LOCAL_HOSTS.includes(window.location.hostname) || !isPlatform(nextPlatform)) return;

  localStorage.setItem(LOCAL_PLATFORM_KEY, nextPlatform);

  const url = new URL(window.location.href);
  url.searchParams.delete('platform');
  window.location.replace(url.toString());
}

export function detectPlatform(location = window.location) {
  const hostname = location.hostname || '';

  if (hostname.endsWith('.bridged.events')) {
    return PLATFORMS.EVENTS;
  }

  const isLocal = LOCAL_HOSTS.includes(hostname);
  const isStg = hostname.startsWith('stg-portal.');
  const params = new URLSearchParams(location.search);

  if (isLocal) {
    return getLocalPlatform(params);
  }

  if (isStg && params.get('platform') === PLATFORMS.EVENTS) {
    return PLATFORMS.EVENTS;
  }

  return PLATFORMS.MEDIA;
}

export function isEventsPlatformValue(platform) {
  return platform === PLATFORMS.EVENTS;
}
